import React from "react";
import { logoFull } from "../assets/logos";

const AuthLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">
    <div className="w-full max-w-md space-y-6">
      <img src={logoFull} alt="ExpTrax" className="h-12 mx-auto" />
      <div className="bg-white p-6 rounded-xl shadow-md">
        {children}
      </div>
    </div>
  </div>
);

export default AuthLayout;
